import { Injectable } from '@angular/core';
import { API_SERVER, API_SERVER_VERSION } from '../../app.constants';
import {HttpClient, HttpEventType, HttpHeaders} from '@angular/common/http';
import {LocalStorageService, SessionStorageService} from 'ng2-webstorage';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UploadModalComponent} from '../upload-modal/upload-modal.component';

@Injectable()
export class FileService {

  private apiUrl = API_SERVER + 'api/' + API_SERVER_VERSION + '/';

  constructor(private http: HttpClient,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService,
              private modalService: NgbModal) {
  }

  upload(file, url, title = ''): Promise<any> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
      if (token && token.expires_at && token.expires_at > new Date().getTime()) {
        headers = headers.append('Authorization', 'Bearer ' + token.access_token);
      }
      const formData = new FormData();
      formData.append('file', file);
      const uploadModal = this.modalService.open(UploadModalComponent, {backdrop: 'static'});
      uploadModal.componentInstance.title = title;
      uploadModal.componentInstance.files = [file];
      uploadModal.componentInstance.status = ['pending'];
      uploadModal.componentInstance.statusMessage = ['Bitte warten. Datei wird hochgeladen.'];
      this.http.post<any>(this.apiUrl + url, formData, { reportProgress: true, observe: 'events', headers: headers })
        .subscribe((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round(100 * event.loaded / event.total);
              uploadModal.componentInstance.bytesTotal = [event.total];
              uploadModal.componentInstance.bytesLoaded = [event.loaded];
              uploadModal.componentInstance.percentage = [progress];
              break;
            case HttpEventType.Response:
              uploadModal.componentInstance.status = ['success'];
              uploadModal.componentInstance.statusMessage = ['Die Datei wurde erfolgreich hochgeladen.'];
              resolve(event);
              break;
            default:
              // console.log('Unhandled event', event);
              break;
          }
        }, error => {
          if (error && error.status && error.status === 200) {
            uploadModal.componentInstance.status = ['success'];
            uploadModal.componentInstance.statusMessage = ['Die Datei wurde erfolgreich hochgeladen.'];
            resolve(event);
          } else {
            console.log('(file.service) Error post file(' + file.name + ' ' + url + ')', error);
            uploadModal.componentInstance.status = ['error'];
            uploadModal.componentInstance.statusMessage = [
              'Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es später erneut.'
              + (error.status) ? ' Status: ' + error.status : ''
            ];
            reject(error);
          }
        });
    });
  }

  uploadMultipleFiles(uploadData: Array<{file: File, url: string}>, title: string = '', resolveOnUserInteraction: boolean,
                      sequentially: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
      if (token && token.expires_at && token.expires_at > new Date().getTime()) {
        headers = headers.append('Authorization', 'Bearer ' + token.access_token);
      }

      const uploadModal = this.modalService.open(UploadModalComponent, {backdrop: 'static'});
      uploadModal.componentInstance.title = title;

      const ready: boolean[] = uploadData.map(() => false);

      Promise.all(uploadData.map((uploadElement, index) => {
        return new Promise((resolve1, reject1) => {
          uploadModal.componentInstance.files[index] = uploadElement.file;
          uploadModal.componentInstance.status[index] = 'pending';
          uploadModal.componentInstance.statusMessage[index] = 'Bitte warten. Dateien werden hochgeladen.';
          const formData = new FormData();
          formData.append('file', uploadElement.file);

          const apiCall = () => {
          this.http.post<any>(this.apiUrl + uploadElement.url, formData, { reportProgress: true, observe: 'events', headers: headers })
            .subscribe((event) => {
              switch (event.type) {
                case HttpEventType.UploadProgress:
                  const progress = Math.round(100 * event.loaded / event.total);
                  uploadModal.componentInstance.bytesTotal[index] = event.total;
                  uploadModal.componentInstance.bytesLoaded[index] = event.loaded;
                  uploadModal.componentInstance.percentage[index] = progress;
                  break;
                case HttpEventType.Response:
                  uploadModal.componentInstance.status[index] = 'success';
                  uploadModal.componentInstance.statusMessage[index] = (uploadData.length > 1)
                    ? 'Die Dateien wurden erfolgreich hochgeladen.' : 'Die Datei wurde erfolgreich hochgeladen.';
                  if (resolveOnUserInteraction) {
                    uploadModal.result.then(() => resolve1(event)).catch(() => resolve1(event));
                  } else {
                    resolve1(event);
                  }
                  ready[index] = true;
                  break;
                default:
                  // console.log('Unhandled event', event);
                  break;
              }
            }, error => {
              if (error && error.status && error.status === 200) {
                uploadModal.componentInstance.status[index] = 'success';
                uploadModal.componentInstance.statusMessage[index] = 'Die Datei wurde erfolgreich hochgeladen.';
                resolve1(event);
                ready[index] = true;
              } else {
                console.log('(file.service) Error post file(' + uploadElement.file.name + ' ' + uploadElement.url + ')', error);
                uploadModal.componentInstance.status[index] = 'error';
                uploadModal.componentInstance.statusMessage[index] =
                  'Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es später erneut.'
                  + (error.status) ? ' Status: ' + error.status : '';
                reject1(error);
                ready[index] = true;
              }
            });
          };

          const checkLastReady = () => {
            if (index === 0 || ready[index - 1] || !sequentially) {
              apiCall();
            } else {
              setTimeout(() => checkLastReady(), 250);
            }
          };

          checkLastReady();
        });
      }))
        .then(promiseAllResolved => {
          // console.log('promiseAllResolved', promiseAllResolved);
          resolve(promiseAllResolved);
        })
        .catch(promiseAllRejected => {
          // console.log('promiseAllRejected', promiseAllRejected);
          reject(promiseAllRejected);
        })
      ;

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/file.service.ts